<template>
  <div class="container">
    <h1>Exporty</h1>
  </div>
</template>

<script>
export default {
  name: "AdminExportsView"
}
</script>

<style scoped>
</style>